<template>
  <div class="introduction-dialog-root">
    <vue-final-modal
      :value="store.visible"
      name="introduction-dialog"
      :classes="['introduction-dialog__container']"
      :content-class="[
        'introduction-dialog',
        'introduction-dialog__shell',
        'v--modal-box',
        'v--modal'
      ]"
      :click-to-close="true"
      :esc-to-close="true"
      :lock-scroll="true"
      attach="body"
      @input="store.setVisible"
    >
      <div
        class="v--modal-close-top"
        v-loading.fullscreen.lock="store.fullscreenLoading"
      >
        <el-button
          @click="store.close"
          icon="el-icon-circle-close"
          style="font-size: 2rem"
          type="text"
        />
      </div>
      <IntroductionRequestForm v-if="isAuthenticated" @submit="onSubmit" />
      <div
        v-else
        style="display: inline-block; min-width: 100%; text-align: center"
      >
        <div style="display: inline-block; min-width: 100%; text-align: center">
          <p style="font-size: 140%">
            <img
              src="/static/renew_img/bnr/recomm_20221005_001.png"
              style="width: 100%"
              alt=""
            />
          </p>
        </div>
        <div style="padding: 20px 0; font-size: 70%">
          Yagishの
          <router-link
            id="footer-link-terms"
            :to="{ name: 'termsPage' }"
            target="_blank"
            >利用規約</router-link
          >、
          <router-link
            id="footer-link-terms"
            :to="{ name: 'policyPage' }"
            target="_blank"
            >個人情報の取り扱い</router-link
          >
          について<br />
          に同意の上、ログインしてください。
        </div>
        <div class="text-center">
          <LoginForms />
        </div>
      </div>
    </vue-final-modal>

    <IntroductionRequestSampleDialog />
  </div>
</template>

<script setup lang="ts">
/**
 * 推薦・紹介文依頼 UI。開閉・状態は Pinia `useIntroductionDialogStore`。
 */
import { getCurrentInstance } from 'vue'
import { useEventListener } from '@vueuse/core'
import LoginForms from '@/components/auth/LoginSpecialForms.vue'
import IntroductionRequestForm from '@/components/format-edit/IntroductionRequestForm.vue'
import IntroductionRequestSampleDialog from '@/components/format-edit/IntroductionRequestSampleDialog.vue'
import { useAuth } from '@/composables/useAuth'
import { useIntroductionDialogStore } from '@/stores/introductionDialog'

type HostVm = {
  $varuna: { endPoints: Record<string, string> }
  $deviceLib: { isOnline: boolean; isMobileDevice: boolean }
  $message: (opts: Record<string, unknown>) => void
}

const vm = getCurrentInstance()!.proxy as unknown as HostVm
const { isAuthenticated } = useAuth()
const store = useIntroductionDialogStore()

function onSubmit() {
  store.submit({
    isOnline: vm.$deviceLib.isOnline,
    isMobileDevice: vm.$deviceLib.isMobileDevice,
    requestIntroductionUrl: vm.$varuna.endPoints.requestIntroduction,
    message: vm.$message
  })
}

useEventListener(window, 'popstate', () => store.close())
</script>

<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<style lang="scss">
.introduction-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 1001;
}

.introduction-dialog__shell.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: calc(100% - 32px);
  max-width: 600px;
  height: auto;
  max-height: 90vh;
  margin-block: auto;
  overflow-y: auto;
  border-radius: 8px;
  padding: 20px;
}
</style>
